import * as React from "react";
const SvgFiRrVihara = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-vihara_svg__a)">
      <path
        fill="#062147"
        d="M23 19c-1.62 0-2.73-3.48-3.014-5.165C19.98 13.8 20 10 20 10h1a1 1 0 0 0 0-2c-1.598 0-2.698-3.383-3-5.092V1a1 1 0 0 0-2 0v1H8V1a1 1 0 0 0-2 0v1.949C5.965 3.288 5.432 8 3 8a1 1 0 0 0 0 2h1s.02 3.8.014 3.835C3.73 15.52 2.62 19 1 19a1 1 0 0 0 0 2h1v2a1 1 0 0 0 2 0v-2h4v2a1 1 0 0 0 2 0v-2h4v2a1 1 0 0 0 2 0v-2h4v2a1 1 0 0 0 2 0v-2h1a1 1 0 0 0 0-2M4.199 19c.886-1.322 1.381-2.99 1.617-4h12.367c.236 1.01.731 2.678 1.617 4zM7.872 4h8.312c.236 1.01.731 2.678 1.617 4H6.415c.874-1.319 1.282-2.982 1.457-4M18 10v3H6v-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-vihara_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVihara;
